import type { SVGProps } from "react";

type IconProps = Omit<SVGProps<SVGSVGElement>, "children" | "viewBox">;

const sharedProps = {
  "aria-hidden": true,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  viewBox: "0 0 24 24",
} as const;

export function ArrowUpIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m6 14 6-6 6 6" />
    </svg>
  );
}

export function ArrowDownIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m6 10 6 6 6-6" />
    </svg>
  );
}

export function NextIncompleteIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M4 12h13M13 8l4 4-4 4M20 6v12" />
    </svg>
  );
}

export function SearchIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <circle cx="10.5" cy="10.5" r="5.5" />
      <path d="m15 15 4 4" />
    </svg>
  );
}

export function CopyIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <rect x="8" y="8" width="10" height="10" rx="1.5" />
      <path d="M15 8V6.5A1.5 1.5 0 0 0 13.5 5h-7A1.5 1.5 0 0 0 5 6.5v7A1.5 1.5 0 0 0 6.5 15H8" />
    </svg>
  );
}

export function BrowseIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <circle cx="6" cy="7" r="1" fill="currentColor" stroke="none" />
      <circle cx="6" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="6" cy="17" r="1" fill="currentColor" stroke="none" />
      <path d="M10 7h8M10 12h8M10 17h8" />
    </svg>
  );
}

export function FollowIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M3.5 12s3.1-5 8.5-5 8.5 5 8.5 5-3.1 5-8.5 5-8.5-5-8.5-5Z" />
      <circle cx="12" cy="12" r="2.3" />
    </svg>
  );
}

export function FilterIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M4 6h16M7 12h10M10 18h4" />
    </svg>
  );
}

export function BackIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m14.5 6-6 6 6 6M9 12h11" />
    </svg>
  );
}

export function InviteIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <circle cx="9" cy="9" r="3" />
      <path d="M3.8 18c.6-2.7 2.4-4.2 5.2-4.2s4.6 1.5 5.2 4.2" />
      <path d="M16 8v6M13 11h6" />
    </svg>
  );
}

export function ProfileIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <circle cx="12" cy="8" r="3.2" />
      <path d="M5.5 19c.8-3.5 3-5.3 6.5-5.3s5.7 1.8 6.5 5.3" />
    </svg>
  );
}

export function ShieldIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M12 3.5 19 6v5.2c0 4.2-2.4 7.3-7 9.3-4.6-2-7-5.1-7-9.3V6z" />
      <path d="m9.2 12 1.8 1.8 3.8-4" />
    </svg>
  );
}

export function ExportIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M12 4v10M8.5 7.5 12 4l3.5 3.5" />
      <path d="M6 12v6.5A1.5 1.5 0 0 0 7.5 20h9a1.5 1.5 0 0 0 1.5-1.5V12" />
    </svg>
  );
}

export function ExpiryIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M19 8V4m0 0h-4M19 4a8 8 0 1 0 1 10" />
      <path d="M12 8v4l2.5 1.5" />
    </svg>
  );
}

export function TrashIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M5 7h14M9 7V4.8h6V7M7.5 7l.7 12h7.6l.7-12M10 10.5v5M14 10.5v5" />
    </svg>
  );
}

export function MenuIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <circle cx="6" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="18" cy="12" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function AddIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v8M8 12h8" />
    </svg>
  );
}

export function BookmarkIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="M7 4.5h10v15l-5-3.3-5 3.3z" />
    </svg>
  );
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg {...sharedProps} {...props}>
      <path d="m7 10 5 5 5-5" />
    </svg>
  );
}
